import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

import { getEventInfo, setEventInfoSubEventId } from 'models/event';

export const sleep = (time: number): Promise<undefined> =>
	new Promise(resolve => setTimeout(resolve, time));

const routes: CustomRoute = {
	path: '/:artisticEventID',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'artisticEventDetail' */ './component')],
			render: ([ArtisticEventDetail]) => <ArtisticEventDetail />,
			onEnter: async ({ next, store, params }) => {
				const { artisticEventID } = params;
				console.log(`on Enter ArtisticEvent/${artisticEventID}`);

				await store.dispatch(getEventInfo(`${artisticEventID}`));
				// 先清空
				await store.dispatch(setEventInfoSubEventId(''));
				await next();
				console.log(`on Enter ArtisticEvent/${artisticEventID} end`);
			},
		},
		{
			path: '/:subArtisticEventID',
			components: () => [import(/* webpackChunkName: 'subArtisticEventDetail' */ './component')],
			render: ([ArtisticEventDetail]) => <ArtisticEventDetail />,
			onEnter: async ({ next, store, params }) => {
				const { artisticEventID, subArtisticEventID } = params;
				console.log(`on Enter ArtisticEvent/${artisticEventID}/${subArtisticEventID}`);
		
				await store.dispatch(getEventInfo(`${artisticEventID}`));
				await store.dispatch(setEventInfoSubEventId(`${subArtisticEventID}`));
				await next();
				console.log(`on Enter ArtisticEvent/${artisticEventID}/${subArtisticEventID} end`);
			},
		},
	],
};

export default routes;
